// Autogenerated file
export const bidEmptyMileageTypesEnum = {
    Normative: "Normative",
    Logistic: "Logistic",
    Technical: "Technical",
};
export const bidEmptyMileageTypes = [
    { label: "Нормативный", value: "Normative" },
    { label: "Логистический", value: "Logistic" },
    { label: "Технический", value: "Technical" },
];
